import { getConfig } from '@klpkonsern/appconfig';
import { IconName } from '@klp/design/Illustrations';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klp/routing';
import type { User } from '@klp/user';

// Extend AppConfigParameters for this module
declare global {
    interface AppConfigParameters {
        WEBAPP_OPPSLAGSTAVLE_ENABLE: boolean;
    }
}

// Helper functions
export const getOppslagstavleEnable = (): boolean =>
    getConfig('WEBAPP_OPPSLAGSTAVLE_ENABLE', false);

export const MessageBoardModuleName = 'oppslagstavle';

export const MessageBoardRoutes = {
    moduleRoute: () => generateRoute([MessageBoardModuleName]),
    list: () => generateRoute([MessageBoardModuleName]),
    add: () => generateRoute([MessageBoardModuleName, 'add']),
    single: (messageId?: string | number) =>
        generateRoute([MessageBoardModuleName, messageId ?? '']),
    edit: (messageId: string | number) =>
        generateRoute([MessageBoardModuleName, messageId, 'edit']),
    thumbnail: (messageId?: string | number, attachmentId?: string | number) =>
        generateRoute([
            MessageBoardModuleName,
            messageId ?? 0,
            'file',
            attachmentId,
            'preview',
        ]),
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const OppslagstavleAccess = (_user?: User): boolean =>
    getOppslagstavleEnable();

export const MessageBoardMenuItems = [
    new SidebarMenuItem({
        route: MessageBoardRoutes.list(),
        matchRoute: MessageBoardRoutes.moduleRoute(),
        icon: IconName.MAIL,
        translation: 'frontPage.messages',
        access: OppslagstavleAccess,
    }),
];
